document.addEventListener('DOMContentLoaded', () => {
  const tabMenu = document.querySelectorAll('.vertical-menu__item');
  const tabContent = document.querySelectorAll('.vertical-menu__section');

  // Adiciona a classe 'ativo' ao primeiro conteúdo por padrão
  if (tabContent.length > 0) {
    tabContent[0].classList.add('ativo');
  }

  const activeTab = index => {
    tabMenu.forEach(item => {
      item.classList.remove('ativo');
    });
    tabContent.forEach(section => {
      section.classList.remove('ativo');
    });
    tabMenu[index].classList.add('ativo');
    tabContent[index].classList.add('ativo');
  };

  tabMenu.forEach((item, index) => {
    item.addEventListener('click', () => {
      activeTab(index);
    });
  });
});
